<template><!--关于账户-->
  <div style="padding: 10px">
    <div>关于账户</div>
    <hr>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="修改信息" name="1">
        <div class="collapse-item-div">● 在“我的”界面中点击左上角头像右下角的编辑按钮可以进入个人资料修改。</div>
        <div class="collapse-item-div">● 头像、昵称、签名和所在地支持更改，性别注册后不可更改。</div>
        <div class="collapse-item-div">● 暂不支持修改注册手机号。</div>
      </el-collapse-item>
      <el-collapse-item title="用户个人页异常" name="2">
        <div class="collapse-item-div">● 用户个人页提示异常，表明改用户由于违反平台规则处于被封禁期。</div>
        <div class="collapse-item-div">● 用户个人页提示该用户消失了，表明该用户已注销账号。</div>
      </el-collapse-item>
      <el-collapse-item title="登录方式" name="3">
        <div class="collapse-item-div">● 目前app支持手机号验证码登录和手机号一键快捷登录，暂不支持密码登录。</div>
      </el-collapse-item>
      <el-collapse-item title="认证相关" name="4">
        <div class="collapse-item-div">● 认证用户可以在平台中得到更多展示机会。</div>
        <div class="collapse-item-div">● 认证的内容仅作为平台验证使用不会对外展示。</div>
        <div class="collapse-item-div">● 每个人只能认证一个账号，再次认证其他账号将被拒绝。</div>
        <div class="collapse-item-div">● 认证将在24小时内处理完成。</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {activeName: '1'}
  },
  methods: {},
  created() {
  }
}
</script>

<style>

</style>
